export default {
  title: 'Desempenho recente de campanhas',
  recipients: '{{recipients}} destinatários',
  error_messages: {
    failed_to_load_data: 'Falha ao carregar dados',
  },
};
